import React, { useEffect, useState } from 'react';
import { useRecoilValue, useRecoilCallback, useRecoilState } from 'recoil';
import {
  businessList,
  productListFetchByBusinessId,
  applicationListFetchByBusinessId,
  fetchApplication,
  pageTitleSubmit
} from '../../recoil';
import {
  useLocation,
  useNavigate
} from 'react-router-dom';
import {pageNames} from '../../helpers';
import { appStatuses } from '../../constants';
import { extractPathInfo } from '../../helpers/extractPathInfo';
import {
  SelectedBusiness,
  SelectedNewProduct,
  NewProductSvg,
  Business,
  // HelpSvg,
  // ProfileSvg,
  LogoutSvg,
  UpArrow,
  DownArrow
} from '../../assets';
import { useLoader } from '../../components/Loader/useLoader';
import { StaticRoutes } from '../../Router';
import {
  TootipComp
} from '../../components';
import './sidebar.css';
import { useTealium } from '../../tealium/useTealium';

export const Sidebar = () => {
  const [openLoader, closeLoader] = useLoader();
  const businessListDetails = useRecoilValue(businessList);
  const [ , setPageTitle] = useRecoilState(pageTitleSubmit);
  const navigate = useNavigate();
  const location = useLocation();
  const [listBusiness, setBusiness] = useState(businessListDetails?.businesses);
  const [listProduct, setProduct] = useState([]);
  const [isNewProductOpen, setIsNewProductOpen] = useState(location?.state === 'submit application' ? false : true);
  const [isMyBusinessesOpen, setMyBusinessesOpen] = useState(false);
  const { track, events } = useTealium();

  // const [isHelpOpen, setHelpOpen] = useState(false);
  // const [isProfile, setProfile] = useState(false);

  const navigateTo = (path) =>
    navigate(path, {
      state: {
        returnPath: location.pathname
      }
    });

  useEffect(() => {
    const segments = location?.pathname?.split('/').filter(Boolean);
    const [resourceType] = segments;
    if (resourceType === 'applications') {
      initializeSideNav();
    }
  }, [location.pathname]);

  useEffect(() => {
    track(events.menubar.pageView());
  }, []);

  const fetchedProductListCallback = useRecoilCallback(({ snapshot }) => async (businessId) => {
    openLoader();
    let data = await snapshot.getPromise(productListFetchByBusinessId(businessId));
    closeLoader();
    if (data.data.error) {
      navigateTo('/dashboard');
    }
    return data;
  });

  const fetchedApplicationListCallback = useRecoilCallback(({ snapshot }) => async (businessId) => {
    openLoader();
    let data = await snapshot.getPromise(applicationListFetchByBusinessId(businessId));
    closeLoader();
    if (data.data.error) {
      navigateTo('/dashboard');
    }
    return data;
  });

  const handleClickBusines = async () => {
    setMyBusinessesOpen(!isMyBusinessesOpen);
    setIsNewProductOpen(false);
    track(events.menubar.menubarClick('my business clicked'));
    // setHelpOpen(false);
    // setProfile(false);
  };

  useEffect(() => {
    initializeSideNav();
  }, []);

  const getQuoteAvailableStatus = (applicationList) => {
    let isQuoteAvailable = false;
    isQuoteAvailable = applicationList?.some(app => app.applicationStatus === appStatuses.QuoteAvailable);
    return isQuoteAvailable;
  };

  const initializeSideNav = async () => {

    let { resourceType, businessId, applicationId } = extractPathInfo(location?.pathname);
    let applicationDetails = applicationId ? await fetchedApplicationCallback(applicationId) : null;
    businessId = applicationDetails ? applicationDetails.businessId : businessId;

    if (!businessId) {
      return;
    }
    const applicationList = await fetchedApplicationListCallback(businessId);
    const quoteAvailableStatus = getQuoteAvailableStatus(applicationList?.data?.applications);

    const businessList = listBusiness?.map(businessItem => {
      return {
        ...businessItem,
        isSelected: businessItem?.businessId === businessId,
        isQuoteAvailable: quoteAvailableStatus
      };
    });

    setMyBusinessesOpen(true);
    setBusiness(businessList);

    const productListResponse = await fetchedProductListCallback(businessId);
    const activeProducts = productListResponse?.data?.activeProducts || [];
    const mappedProductList = activeProducts.map(product => {
      if(product?.applicationId === applicationId) {
        const productName = pageNames[product?.product];
        setPageTitle({productName: productName});
      }
      return {
        ...product,
        isSelected: product?.applicationId === applicationId
      };
    });

    setProduct(mappedProductList);

    if (applicationId) {
      setIsNewProductOpen(false);
    }

    if (resourceType === 'quotes') {
      const mappedBusinessList = businessList?.map(businessItem => {
        return {
          ...businessItem,
          isFundingQuoteSelected: businessItem?.businessId === businessId,
          isMyApplicationSelected: false,
          isQuoteAvailable: true
        };
      });
      setIsNewProductOpen(false);
      setBusiness(mappedBusinessList);
    }

    if (resourceType === 'applications') {
      const mappedBusinessList = businessList?.map(businessItem => {
        return {
          ...businessItem,
          isMyApplicationSelected: businessItem?.businessId === businessId,
          isFundingQuoteSelected: false,
          isQuoteAvailable: quoteAvailableStatus
        };
      });

      setIsNewProductOpen(false);
      setBusiness(mappedBusinessList);
    }

  };

  const fetchedApplicationCallback = useRecoilCallback(({ snapshot }) => async (applicationId) => {
    const data = await snapshot.getPromise(fetchApplication(applicationId));
    return data;
  });

  const fetchProducts = async (businessId) => {
    const productList = await fetchedProductListCallback(businessId);
    setProduct(productList?.data?.activeProducts || []);
  };

  const handleSelectBusiness = async (selected, businessId) => {
    const applicationList = await fetchedApplicationListCallback(businessId);
    const quoteAvailableStatus = getQuoteAvailableStatus(applicationList?.data?.applications);
    const businessList = listBusiness?.map(businessItem => {
      if (businessItem?.businessId === businessId) {
        return {
          ...businessItem,
          isSelected: !selected,
          isMyApplicationSelected: false,
          isFundingQuoteSelected: false,
          isQuoteAvailable: quoteAvailableStatus
        };
      } return {
        ...businessItem,
        isSelected: false,
        isMyApplicationSelected: false,
        isFundingQuoteSelected: false,
        isQuoteAvailable: quoteAvailableStatus
      };
    });
    setBusiness(businessList);
    setIsNewProductOpen(false);
    fetchProducts(businessId);
    track(events.menubar.menubarClick('business clicked'));
  };

  const handleSelectApplication = async (businessId) => {
    setBusiness(listBusiness?.map(busines => { return { ...busines, isMyApplicationSelected: true, isFundingQuoteSelected: false }; }));
    setProduct(listProduct?.map(product => { return { ...product, isSelected: false }; }));
    setIsNewProductOpen(false);
    track(events.menubar.menubarClick('my application clicked'));
    navigateTo(`/applications/${businessId}`);
  };

  const handleSelectFundingQuote = async (businessId) => {
    setBusiness(listBusiness?.map(busines => { return { ...busines, isMyApplicationSelected: false, isFundingQuoteSelected: true, isQuoteAvailable: true }; }));
    setProduct(listProduct?.map(product => { return { ...product, isSelected: false }; }));
    setIsNewProductOpen(false);
    track(events.menubar.menubarClick('funcding quote clicked'));
    navigateTo(`/quotes/${businessId}`);
  };

  const handleClickNewProduct = () => {
    setIsNewProductOpen(true);
    setMyBusinessesOpen(false);
    // setHelpOpen(false);
    // setProfile(false);
    track(events.menubar.menubarClick('apply a for new product clicked'));
    navigateTo('/dashboard');
  };

  const handleSelectProduct = (selectedProduct, selected) => {
    const product = listProduct.map(product => {
      if (product?.applicationId === selectedProduct.applicationId) {
        return {
          ...product,
          isSelected: !selected
        };
      } return {
        ...product,
        isSelected: false
      };
    });
    const productName = pageNames[selectedProduct?.product];
    setPageTitle({pageTitle: productName});
    setBusiness(listBusiness?.map(businesItem => { return { ...businesItem, isMyApplicationSelected: false, isFundingQuoteSelected: false }; }));
    setIsNewProductOpen(false);
    setProduct(product);
    track(events.menubar.menubarClick('product clicked'));
    navigateTo(`/accounts/${selectedProduct.applicationId}`);
  };

  // const handleClickHelp = () => {
  //   setHelpOpen(true);
  //   setIsNewProductOpen(false);
  //   setMyBusinessesOpen(false);
  //   setProfile(false);
  // };

  // const handleClickProfile = () => {
  //   setIsNewProductOpen(false);
  //   setMyBusinessesOpen(false);
  //   setHelpOpen(false);
  //   setProfile(true);
  // };

  return (
    <aside className="sidebar">
      <ul className="menu">
        <li>
          <button className={isNewProductOpen ? 'selected-top-menu-item pl-0' : 'top-menu-item'} onClick={() => handleClickNewProduct()}>
            {isNewProductOpen ? <span className='left-border' >|</span> : ''}
            {isNewProductOpen ? <img src={SelectedNewProduct} alt='' /> : <img src={NewProductSvg} alt='' />} <span className='ml-10'>Apply for a new product </span>
          </button>
          <div className='divider' />
        </li>

        <li>
          <button
            className={isMyBusinessesOpen ? 'selected-menu pl-0' : 'menu-item'}
            onClick={() => handleClickBusines()}
          >
            {
              isMyBusinessesOpen ?
                <span className='left-border' >|</span> : ''}
            {isMyBusinessesOpen ? <img src={SelectedBusiness} alt='' /> : <img src={Business} alt='' />}  <span className='ml-10'>My Businesses</span>
            {isMyBusinessesOpen ?
              <img className='icon' src={UpArrow} alt='' /> :
              <img className='icon' src={DownArrow} alt='' />
            }
          </button>
          <div className='divider' />
          {isMyBusinessesOpen && (
            <ul className="submenu">
              {listBusiness?.map((business, index) => {
                return (<li key={`busines${index}`}>
                  <button
                    className={business?.isSelected ? 'selected-menu pl-0 pb-14 pt-12' : 'menu-item pl-0'}
                    onClick={() => handleSelectBusiness(business?.isSelected, business?.businessId)}
                  >
                    <TootipComp text={business?.businessName} />
                    {business?.isSelected ?
                      <img className='icon' src={UpArrow} alt='' /> :
                      <img className='icon' src={DownArrow} alt='' />
                    }
                  </button>
                  <div className='divider ml-20 wd-109' />
                  {business?.isSelected && (
                    <ul className="submenu">
                      {business?.isQuoteAvailable &&
                      <>
                        <button className={business?.isFundingQuoteSelected ? 'selected-menu pl-0 pb-14 pt-12' : 'menu-item pl-0'}
                          onClick={() => handleSelectFundingQuote(business?.businessId)}
                        ><span className='application-list-item-style'>.</span > <span className='ml-10'> Funding Quote</span></button>
                        <div className='divider ml-40 wd-119' />
                      </>
                      }
                      <button className={business?.isMyApplicationSelected ? 'selected-menu pl-0 pb-14 pt-12' : 'menu-item pl-0'}
                        onClick={() => handleSelectApplication(business?.businessId)}
                      ><span className='application-list-item-style'>.</span > <span className='ml-10'> My Applications</span></button>
                      <div className='divider ml-40 wd-119' />
                      {
                        listProduct?.map((product, index) => {
                          return (
                            <li key={`product${index}`}>
                              {product?.status === 'Active' && product?.product && (
                                <>
                                  <button className={product.isSelected ? 'selected-menu pl-0 pb-14 pt-12' : 'menu-item pl-0'}
                                    onClick={() => handleSelectProduct(product, product?.isSelected)}
                                  ><span className='application-list-item-style'>.</span>
                                    <TootipComp text={product?.productCode === 'RCF' ? 'Cash Flow Facility' : product?.product} />
                                  </button>
                                  <div className='divider ml-40 wd-119' />
                                </>
                              )
                              }
                            </li >
                          );
                        })
                      }
                    </ul >
                  )}
                </li >);
              })}
            </ul >
          )}
        </li >
        {/* commenting the links for now as we may continue on theses two feature in phase 2 */}
        {/* <li>
          <button className={isHelpOpen ? 'selected-menu pl-0' : 'menu-item'} onClick={handleClickHelp}>{isHelpOpen ? <span className='left-border' >|</span> : ''}<img src={HelpSvg} alt='' /><span className='ml-10'>Help centre</span></button><div className='divider' />
        </li>
        <li>
          <button className={isProfile ? 'selected-menu pl-0' : 'menu-item'} onClick={handleClickProfile}>{isProfile ? <span className='left-border' >|</span> : ''}<img src={ProfileSvg} alt='' /><span className='ml-10'>My profile</span></button><div className='divider' />
        </li> */}
        <li>
          <button className="bottom-menu-item" onClick={() => {track(events.menubar.menubarClick('logout clicked'));navigateTo(StaticRoutes.logout);}} ><img src={LogoutSvg} alt='' /><span className='ml-10'>Logout</span></button><div className='divider' />
        </li>
      </ul >
    </aside >
  );
};

Sidebar.propTypes = {};
